// API Configuration
export const API_CONFIG = {
    baseURL: 'https://accountsplanet.com/api/',
    apiKey: '204cf05dbe204c8f49792f94627fdae4189ee1114e7e3469a07ff23eba269aae'
};

export default API_CONFIG;